import React, { useState, useEffect, useReducer } from "react";
import moment from "moment";
import {
  Grid,
  Typography,
  Backdrop,
  CircularProgress,
  CardContent,
  Card,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  makeStyles,
  Box,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import useStyles from "../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import "react-datepicker/dist/react-datepicker.css";
import "../../../css/employee-page.css";
import { useNotification } from "../../../hooks/useNotification.js";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useLocation } from "react-router-dom";

import sys_icon_windows from "../../../images/employee/windows.png";
import sys_icon_linux from "../../../images/employee/linux.png";
import sys_icon_mac from "../../../images/employee/mac.png";
import sys_icon_android from "../../../images/employee/android.png";
import sys_icon_ios from "../../../images/employee/ios.png";
import sys_icon_faq from "../../../images/employee/ios.png";
import { FaRegCalendarAlt } from "react-icons/fa";

const useCardStyles = makeStyles((theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  card: {
    margin: theme.spacing(1),
    display: "flex",
    alignItems: "center",
  },
  icon: {
    marginRight: theme.spacing(2),
  },
}));

const systemIcons = {
  Windows: (
    <img
      src={sys_icon_windows}
      style={{ width: "60px", margin: "0px 12px" }}
      alt="windows"
    />
  ),
  Linux: (
    <img
      src={sys_icon_linux}
      style={{ width: "60px", margin: "0px 12px" }}
      alt="linux"
    />
  ),
  MacOS: (
    <img
      src={sys_icon_ios}
      style={{ width: "60px", margin: "0px 12px" }}
      alt="ios"
    />
  ),
  Android: (
    <img
      src={sys_icon_android}
      style={{ width: "60px", margin: "0px 12px" }}
      alt="android"
    />
  ),
  Other: (
    <img
      src={sys_icon_faq}
      style={{ width: "60px", margin: "0px 12px" }}
      alt="other"
    />
  ),
};

// Function to Get System Name from User Agent

export default function AdminAttendanceDetails() {
  const classes = useStyles();
  const cardClasses = useCardStyles();
  const token = localStorage.getItem("token");
  const location = useLocation();
  const userId = new URLSearchParams(location.search).get("userId");
  const employeeName = new URLSearchParams(location.search).get("fullName");
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const handleNotificationCall = useNotification();

  const [loader, setLoader] = useState(false);
  const [viewAttendanceData, setViewAttendaceData] = useState([]);

  useEffect(() => {
    fetchAttendancesData();
  }, []);

  const fetchAttendancesData = async () => {
    try {
      setLoader(true);
      axios({
        method: "get",
        url: `${process.env.REACT_APP_SERVER}employee/getAdminAttendanceDetails?userId=${userId}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setViewAttendaceData(response.data.data);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  // function getEmpName(user) {
  //   let empName;
  //   if (user.employee) {
  //     empName = user.employee.firstName + " " + user.employee.lastName;
  //   }

  //   if (user.recruiter) {
  //     empName = user.recruiter.firstName + " " + user.recruiter.lastName;
  //   }
  //   return empName;
  // }

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title={`Login Monitor Details: ${employeeName}`} />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        {viewAttendanceData.map((day) => (
          <Grid item xs={12}>
            <Accordion key={day.formattedDate}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id={`${day.formattedDate}-header`}
              >
                <Box display="flex" alignItems="center" gridGap={10}>
                  <FaRegCalendarAlt size={20} color="#110d65" />
                  <Typography className={cardClasses.heading}>
                    {day.formattedDate}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  {day.records.map((record) => {
                    return (
                      <Grid item xs={12} sm={6} md={4} key={record.id}>
                        <Card className={cardClasses.card}>
                          {systemIcons[record.system] || systemIcons.Other}
                          <CardContent>
                            <Typography variant="h6">
                              {record.system}
                            </Typography>
                            <Typography variant="body2">
                              IP: {record.ipAddress}
                            </Typography>
                            <Typography
                              variant="body2"
                              style={{ color: "#2d9004" }}
                            >
                              Login Time:{" "}
                              {moment(record.createdAt).format("LT")}
                            </Typography>
                            <Typography
                              variant="body2"
                              style={{ color: "#FF0000" }}
                            >
                              Logout Time:{" "}
                              {record.logoutTime
                                ? moment(record.logoutTime).format("LT")
                                : "-"}
                            </Typography>
                            <Typography variant="body2">
                              Location: {record.city}, {record.regionName},{" "}
                              {record.country}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Grid>
                    );
                  })}
                </Grid>
              </AccordionDetails>
            </Accordion>
          </Grid>
        ))}
      </Grid>

      <Grid item xs={12}>
        {viewAttendanceData.length === 0 && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="300px"
          >
            <Typography variant="body2">No Data Found here</Typography>
          </Box>
        )}
      </Grid>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
